module.exports = __webpack_public_path__ + "static/media/Camadas.8b69c3cc.svg";